function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M46.394 11.645S40.14 21 27.64 22c-12.5.999-18.52-4.788-18.52-4.788",
  stroke: "#A0AFBE",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.317 15.239a.5.5 0 01.52-.723l8.477 1.296c.533.08.578.83.06.975l-3.666 1.022a.5.5 0 00-.365.468l-.12 4.473c-.014.518-.708.675-.945.215l-3.96-7.726z",
  fill: "#A0AFBE"
});
function SvgGreyArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgGreyArrow;